import { InjectionToken } from '@angular/core';

import { LocaleConfig } from './locale-config.model';

export const LOCALE_CONFIG = new InjectionToken<LocaleConfig>('CURRENT_LOCALE');
